import ModelService from './model.service';

const AnimationsListService = new ModelService('/animations-lists', '/animations-lists', 'animations');

AnimationsListService.getImage = (filename, w = false, h = false, c = false) => AnimationsListService.getFilePathByDir('/uploads/animations', filename, w, h, c);

AnimationsListService.STATUS_INACTIVE = 0;
AnimationsListService.STATUS_ACTIVE = 1;

AnimationsListService.getStatusList = t => ({
  [AnimationsListService.STATUS_INACTIVE]: t('Inactive'),
  [AnimationsListService.STATUS_ACTIVE]: t('Active'),
});

AnimationsListService.getStatusOptions = t => AnimationsListService
  .prepareOptionsFromSimpleObject(AnimationsListService.getStatusList(t));

AnimationsListService.getColorByStatus = (status) => {
  switch (status) {
    case AnimationsListService.STATUS_INACTIVE:
      return 'danger';
    case AnimationsListService.STATUS_ACTIVE:
      return 'success';
    default:
      return 'secondary';
  }
};

AnimationsListService.getStatusTitle = (status, t) => {
  const label = AnimationsListService.getStatusList(t)[status];
  return label || '-';
};

export default AnimationsListService;



// WEBPACK FOOTER //
// ./src/services/animationsList.service.js